import React from 'react';
import { useSelector } from 'react-redux';

import { getSelectedSelfServiceId } from 'modules/auth/selectors';

import { useGetSelfServiceByIdQuery } from 'modules/selfServices/service';

type UsePreAuthorizedAmountsProps = {
  selfServiceId?: string,
};

const usePreAuthorizedAmounts = ({ selfServiceId: selfServiceIdProp }: UsePreAuthorizedAmountsProps = {}) => {
  const storeSelfServiceId = useSelector(getSelectedSelfServiceId);

  const selfServiceId = selfServiceIdProp ?? storeSelfServiceId;
  const { data: selfService } = useGetSelfServiceByIdQuery({ id: selfServiceId });

  const customerPreAuthorizedAmount = selfService.preAuthorizedAmounts?.CUSTOMER;
  const hasCustomerPreAuthorizedAmount = typeof customerPreAuthorizedAmount === 'number' && customerPreAuthorizedAmount >= 0;

  const leaserPreAuthorizedAmount = selfService.preAuthorizedAmounts?.LEASER;
  const hasLeaserPreAuthorizedAmount = typeof leaserPreAuthorizedAmount === 'number' && leaserPreAuthorizedAmount >= 0;

  return React.useMemo(() => ({
    customerPreAuthorizedAmount,
    hasCustomerPreAuthorizedAmount,
    leaserPreAuthorizedAmount,
    hasLeaserPreAuthorizedAmount,
  }), [customerPreAuthorizedAmount, hasCustomerPreAuthorizedAmount, leaserPreAuthorizedAmount, hasLeaserPreAuthorizedAmount]);
};

export default usePreAuthorizedAmounts;
